import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { formatCurrency, pluralize } from '../../utils/format';

// Compact copy of the summary, fixed under the site header once the cards scroll away (top from
// hooks/usePinnedSummary).
export function PinnedSummary({ visible, top, summary: s, scope }) {
  const scopeText = scope === 'selected' ? pluralize(s.count, 'selected') : scope === 'filtered' ? `${s.count} filtered` : `All ${s.count}`;
  const metrics = [
    { label: 'Due', value: formatCurrency(s.amountDue), tone: s.amountDue ? 'tw-text-amber-700' : undefined },
    { label: 'Collected', value: `${s.collectedPct}%` },
    { label: 'Registered', value: s.registered },
    { label: 'Overnight / Commuter', value: `${s.overnight} / ${s.commuter}` },
    { label: 'Documents', value: `${s.documentsComplete}/${s.registered}`, tone: s.missingDocuments ? 'tw-text-amber-700' : undefined },
    { label: 'Coupons', value: formatCurrency(s.couponTotal) },
  ];

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: '-100%', opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: '-100%', opacity: 0 }}
          transition={{ duration: 0.2, ease: [0.23, 1, 0.32, 1] }}
          style={{ top }}
          className="reports-page tw-fixed tw-inset-x-0 tw-z-30 tw-border-b tw-border-neutral-200 tw-bg-white/95 tw-font-sans tw-backdrop-blur"
          aria-label="Summary">
          <div className="tw-mx-auto tw-flex tw-max-w-[1440px] tw-items-center tw-gap-6 tw-overflow-x-auto tw-px-4 tw-py-2.5 sm:tw-px-6 lg:tw-px-10">
            <span className="tw-flex tw-shrink-0 tw-items-center tw-gap-2 tw-text-xs tw-font-medium tw-text-brand-600">
              <span className="tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-brand-600" aria-hidden />
              {scopeText}
            </span>
            {metrics.map(m => (
              <span key={m.label} className="tw-flex tw-shrink-0 tw-items-baseline tw-gap-1.5 tw-text-sm">
                <span className="tw-text-xs tw-text-neutral-500">{m.label}</span>
                <span className={`tw-font-semibold tw-tabular-nums ${m.tone ?? 'tw-text-neutral-900'}`}>{m.value}</span>
              </span>
            ))}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
